import { createReducer } from '@reduxjs/toolkit';
import { LastStateShape } from './model';
import * as lastStateActions from './actions';

const initial: LastStateShape = {
  appliedId: null,
};

export const lastStateReducer = createReducer<LastStateShape>(initial, (builder) =>
  builder
    .addCase(lastStateActions.applied, (s, a) => {
      s.appliedId = a.payload?.id || null;
    })
    .addCase(lastStateActions.saved, (s, a) => {
      s.appliedId = a.payload.id;
    }),
);
